import React from "react";
import { usePagination } from "ahooks";
import { getAppSubscriptionOrderList } from "@/services/api/appSubscriptionOrder";
import { useParams } from "react-router";
import { useGlobalStore } from "@/store/hooks";
import AppSubscriptionOrderTable from "@/scenes/setting/Shop/AppSubscription/components/AppSubscriptionOrderTable";
import { observer } from "mobx-react-lite";

interface SubscriptionOrderListProps {}

/**
 * 查看某个店铺下订购记录列表
 */
const SubscriptionOrderList: React.FC<SubscriptionOrderListProps> = observer(function (props) {
    const params = useParams<{ shopId: string }>();
    const shopId = Number(params.shopId);

    const globalStore = useGlobalStore();
    const shop = globalStore.shopMapping.get(shopId);

    const { pagination, loading, data, refreshAsync } = usePagination(
        async ({ pageSize, current }) => {
            if (!shop) {
                return {
                    total: 0,
                    list: [],
                };
            }

            const { items, totalCount } = await getAppSubscriptionOrderList({
                shopId,
                pageNo: current,
                pageSize,
            });

            return {
                total: totalCount,
                list: items,
            };
        },
    );

    if (!shop) {
        return <div>出错了，请联系客服反馈</div>;
    }

    return (
        <div>
            <h2>{shop?.name}&nbsp;订购记录</h2>
            <AppSubscriptionOrderTable
                shopId={shopId}
                pagination={pagination}
                loading={loading}
                dataSource={data?.list}
                refresh={refreshAsync}
            />
        </div>
    );
});

export default SubscriptionOrderList;
